<template>
  <v-container grid-list-xs>
    <v-container>
      <v-card>
        <v-card-title>Comisiones</v-card-title>
        <v-card-text>

          <v-row>
            <v-col>
              <v-data-table :headers="headers" :items="listaComision" class="elevation-1" :loading="loading">
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon small class="mr-2" @click="editarComision(item)">mdi-pencil</v-icon>
                  <v-icon small @click="eliminar(item.Id)">mdi-delete</v-icon>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>




  </v-container>
</template>

<script>
import Comisionservice from "../../services/Comision.service";

export default {
  data() {
    return {
      headers: [
        { text: "Id", value: "comisionId" },
        { text: "Nombre", value: "nombre" },
        { text: "Actividad", value: "actividad" },
        { text: "Alumnos", value: "cantAlumnos" },
        { text: "Tutorias", value: "cantTutorias" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      loading: false,
      listaComision: [],
      dialogo: false,
    };
  },
  methods: {
    cargarTablaComision() {
      this.loading = true;
      Comisionservice.ObtenerTodo().then((res) => {
        this.listaComision = res.data;
           this.loading = false;
      });
    },
  },
  mounted() {
    this.cargarTablaComision();
  },
};
</script>

<style>
</style>